import styled from "styled-components";
import { header } from "../Data";
function Header() {
  return (
    <Wrap>
      {/* logo */}
      <Logo>
        <a href="#home-card">
          <span>SHAROOQ</span>
        </a>
      </Logo>
      {/* menu */}
      <TopMenu>
        {header.menu.map((item) => {
          const { id, url, text, icon } = item;
          return (
            <li key={id}>
              <a href={`${url}`}>
                <span className={`icon la ${icon}`}></span>
                <span className="link">{text}</span>
              </a>
            </li>
          );
        })}
      </TopMenu>
      {/* socials */}
      <Social>
        {header.social.map((item, id) => {
          const { link, icon } = item;
          return (
            <a key={id} target="_blank" href={`${link}`} rel="noreferrer">
              <span className={`icon la ${icon}`}></span>
            </a>
          );
        })}
      </Social>
    </Wrap>
  );
}

export default Header;

const Wrap = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 60px;
  z-index: 113;
  display: flex;
  text-align: center;
  font-size: 13px;

  background: #181818;
`;

const Logo = styled.div`
  margin-left: 30px;
  margin-top: auto;
  margin-bottom: auto;
  display: flex;
  font-size: 26px;
  /* align-items: center; */

  @media (max-width: 852px) {
    display: none;
  }
`;

const TopMenu = styled.div`
  margin: auto;
  width: auto;
  max-width: 600px;
  font-size: inherit;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: space-between;
  color: #ffffff;

  li {
    list-style: none;
    margin-left: 10px;
    margin-right: 10px;
    display: inline-block;
  }

  a {
    width: 100%;
    /* font-size: 13px; */
    display: flex;
    align-items: center;

    .icon {
      font-size: 22px;
    }

    span:nth-child(2) {
      text-transform: uppercase;
      letter-spacing: 2px;
      padding: 2px 4px;
      white-space: nowrap;
      position: relative;

      &:before {
        background-color: rgb(249, 249, 249);
        border-radius: 0px 0px 4px 4px;
        bottom: -4px;
        content: "";
        height: 2px;
        left: 4px;
        opacity: 0;
        position: absolute;
        right: 6px;
        transform-origin: left center;
        transform: scaleX(0);
        transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;
        visibility: hidden;
        width: auto;
      }
    }
    &:hover {
      span:before {
        transform: scaleX(1);
        visibility: visible;
        opacity: 1 !important;
      }
    }
  }

  @media (max-width: 768px) {
    .icon {
      font-size: 20px;
    }

    .link:before {
      display: none;
    }
  }

  @media (max-width: 560px) {
  font-size: 12px;

    .icon {
      display: none;
    }

    .link:before {
      display: none;
    }
  }
`;

const Social = styled.div`
  margin-right: 30px;
  margin-top: auto;
  margin-bottom: auto;
  display: flex;
  font-size: 22px;
  align-items: center;

  a {
    padding: 0px 10px;
  }

  @media (max-width: 1068px) {
    display: none;
  }
`;
